import React, { FC } from 'react';

import { fontFamilies } from 'components/UI/Font';

export const Tabs: FC<{
  currentDesktopTab: string;
  gridArea: string;
  setCurrentDesktopTab: (tab: string) => void;
  tabs: string[];
}> = ({ currentDesktopTab, gridArea, setCurrentDesktopTab, tabs }) => {
  return (
    <div className="tabs desktop">
      <div className="names">
        {tabs.map(tabName => (
          <h2
            className={`tab ${currentDesktopTab !== tabName ? 'inactive' : ''}`}
            onClick={() => {
              setCurrentDesktopTab(tabName);
            }}
          >
            {tabName}
          </h2>
        ))}
      </div>
      <div className="line" />
      <style jsx>{`
        .tabs {
          grid-area: ${gridArea};
        }

        .names {
          height: 26px;
          width: 100%;
        }

        .line {
          width: 100%;
          border-bottom: 2px solid #eceeef;
        }

        .tab {
          font-family: ${fontFamilies.bold};
          font-size: 24px;
          float: left;
          margin-right: 60px;
          line-height: 24px;
          cursor: pointer;
        }
        .tab.inactive {
          color: #eceeef;
        }
        .tab.inactive:hover {
          color: inherit;
        }
      `}</style>
    </div>
  );
};
